export default function () {
    require('pace').start({
        document: false,
        ajax: {
            trackMethods: ['GET', 'POST'],
        },
    });
}



// WEBPACK FOOTER //
// ./assets/js/theme/global/loading-progress-bar.js